import { createContext } from 'react';

const FilterContext = createContext(null);

export default FilterContext;

